// =============================================================================
// HOME Routes
// =============================================================================

export default {
  path: 'dashboard',
  name: 'home',
  component: () => import(/* webpackChunkName: "home" */ '../../views/admin/Home.vue'),
  meta: {
    pageTitle: 'داشبورد',
    pageTitleI18n: 'pages.dashboard.title'
  }
}
